import Toolbar from '@mui/material/Toolbar'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import FixedAppBar from '../components/shared/FixedAppBar'
import { useAuth } from '../context/useAuth'

const ProtectedRoutes = () => {
  const location = useLocation()
  const { auth } = useAuth()
  if (auth.isInitialized) return null
  return auth.isAuthenticated ? (
    <>
      <FixedAppBar />
      <Toolbar variant='dense' />
      <Outlet />
    </>
  ) : (
    <Navigate to='/login' replace={true} state={{ from: location }} />
  )
}

export default ProtectedRoutes
